let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g9ZMx")).then(() => parcelRequire('g4biE'));